import { render, staticRenderFns } from "./SupplierCard.vue?vue&type=template&id=d6434e7e&scoped=true&"
import script from "./SupplierCard.vue?vue&type=script&lang=js&"
export * from "./SupplierCard.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCard.vue?vue&type=style&index=0&id=d6434e7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6434e7e",
  null
  
)

export default component.exports